/* SnapTint kit builder for sections/st-vehicle-page.liquid.
   Picks the kit variant from (vehicle size, film), adds Ultra Nano upgrades (one per window group set to Ultra Nano),
   the windshield strip ("With complete kit" price on a Complete kit, as X-Cart did) and the tool kit,
   and adds everything to the cart with the vehicle, year and shades as line-item properties.
   Also drives the live previews (snippets/st-car, [data-st-car]), the film price differences, the order summary and the
   state tint-law check (assets/st-tint-laws.json from TintCenter's law data, scripts/shopify/build_tint_law_asset.py):
   shades darker than the chosen state allows are marked, but can still be ordered (exemptions, off-road, show cars). */
(function () {
  var form = document.querySelector('[data-st-builder]');
  var cfgEl = document.querySelector('[data-st-config]');
  if (!form || !cfgEl) return;
  var cfg = JSON.parse(cfgEl.textContent);
  var GROUPS = { complete: ['front', 'back', 'rear'], back: ['back', 'rear'], front: ['front'], rear: ['rear'] };
  var GROUP_NAMES = { front: 'Front windows', back: 'Back windows', rear: 'Rear windshield' };
  // Body type on the order line, in the customer's words (T38: the raw code "truck2" showed in order emails). The finder's
  // codes come from vehicle.body_type (scripts/shopify/setup_vehicles.py); "truck" stays in the pickup names because the
  // account pages look for it (apps/snap-tint-customer-accounts kit.js: /suv|van|truck/).
  var BODY_NAMES = { coupe: 'Coupe', sedan: 'Sedan', suv: 'SUV', wagon: 'Wagon', van: 'Van',
    truck: 'Pickup truck, 2-door', truck2: 'Pickup truck, 4-door' };
  var NANO = '80% - Ultra Nano';
  var BASE_FILM = 'HP Neutral';
  var $ = function (sel) { return form.querySelector(sel); };
  var $$ = function (sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); };
  // prices come in the shopper's currency (cfg.currency, e.g. USD or CAD); CAD shows as CA$
  var money = function (cents) { try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cfg.currency || 'USD' }).format(cents / 100); } catch (e) { return '$' + (cents / 100).toFixed(2); } };
  var cars = $$('[data-st-car]');
  var lawEl = $('[data-st-law]'), stateSel = $('[data-st-state]'), laws = null;
  var mpv = lawEl && lawEl.dataset.mpv === '1';

  var params = new URLSearchParams(location.search);
  if (params.get('kit') && GROUPS[params.get('kit')]) {
    var r = form.querySelector('input[name="kit"][value="' + params.get('kit') + '"]');
    if (r) r.checked = true;
  }
  if (params.get('year')) {
    var ys = $('#st-year');
    if (ys.tagName === 'SELECT') {
      var has = Array.prototype.some.call(ys.options, function (o) { return o.value === params.get('year'); });
      ys.value = has ? params.get('year') : 'other';
    } else ys.value = params.get('year');
  }
  // "Order this kit again" links from customer accounts (tracker T43): ?film=HP%20Neutral (or the key, e.g. charcoal) and
  // ?front=50&back=20&rear=20 (a percentage, or the full value "50% - Very Light"). Unknown values are left as they are.
  if (params.get('film')) {
    var fv = params.get('film').toLowerCase();
    var fr = Array.prototype.find.call(form.querySelectorAll('input[name="film"]'), function (i) { return i.value.toLowerCase() === fv || (i.dataset.key || '') === fv; });
    if (fr) fr.checked = true;
  }
  ['front', 'back', 'rear'].forEach(function (g) {
    var want = params.get(g);
    if (!want) return;
    var radios = Array.prototype.slice.call(form.querySelectorAll('input[name="' + g + '"]'));
    var hit = radios.find(function (i) { return i.value === want; }) ||
      radios.find(function (i) { return parseInt(i.value, 10) === parseInt(want, 10) && i.value.indexOf('Nano') < 0; });
    if (hit) hit.checked = true;
  });

  function kit() { return form.elements.kit.value; }
  function film() { return form.elements.film.value; }
  function variant(k, f) {
    f = f || film();
    return cfg.kits[k].variants.find(function (v) { return v.s === cfg.size && v.f === f; });
  }
  function strip(k) { return cfg.strip[k === 'complete' ? 'With complete kit' : 'Standard']; }
  function nanoCount(k) {
    return GROUPS[k].filter(function (g) { return g !== 'rear' && form.elements[g].value === NANO; }).length;
  }
  function row(label, value) {
    return '<div><dt>' + label + '</dt><dd>' + value + '</dd></div>';
  }
  function shadePct(val) { return val === NANO ? 80 : parseInt(val, 10); }
  function state() { return laws && stateSel.value && stateSel.value !== 'XX' ? laws.states.find(function (s) { return s.c === stateSel.value; }) : null; }
  // minimum VLT for a window group: 0 any darkness, 100 no film, N more than N%, null unclear
  function minVlt(st, g) {
    if (g === 'front') return st.fv;
    if (g === 'back') return mpv ? st.bmv : st.bv;
    return mpv ? st.rmv : st.rv;
  }
  function tooDark(st, g, val) {
    var min = minVlt(st, g);
    return min !== null && min !== undefined && min > 0 && shadePct(val) <= Math.min(min, 99) || min === 100;
  }
  function lawRule(st, g) { return g === 'front' ? st.f : g === 'back' ? (mpv ? st.bm : st.b) : (mpv ? st.rm : st.r); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function update() {
    var k = kit(), f = film(), groups = GROUPS[k];
    var filmKey = form.querySelector('input[name="film"]:checked').dataset.key;
    var year = $('#st-year').value;

    // shades this film comes in (cfg.filmShades, Qiang 2026-10-02: HP Blue only 50%, HP Bronze only 20% and 35%); the clear
    // 80% options are a different, clear film and stay for every kit. A shade that disappears snaps to the first one left.
    var allowed = (cfg.filmShades || {})[f] || null;
    form.querySelectorAll('.st-shades[data-st-group] .st-shade').forEach(function (lab) {
      var inp = lab.querySelector('input[type="radio"]'), pct = inp.value.split(' - ')[0];
      var ok = !allowed || pct === '80%' || allowed.indexOf(pct) >= 0;
      lab.hidden = !ok;
      if (!ok && inp.checked) inp.checked = false;
    });
    form.querySelectorAll('.st-shades[data-st-group]').forEach(function (fs) {
      var radios = fs.querySelectorAll('input[type="radio"]');
      if (!radios.length || Array.prototype.some.call(radios, function (r) { return r.checked; })) return;
      var pick = Array.prototype.filter.call(radios, function (r) { return !r.closest('.st-shade').hidden && r.value.split(' - ')[0] !== '80%'; })[0]
        || Array.prototype.filter.call(radios, function (r) { return !r.closest('.st-shade').hidden; })[0];
      if (pick) pick.checked = true;
    });

    // steps shown for this kit
    form.querySelectorAll('[data-st-group]').forEach(function (el) { el.hidden = groups.indexOf(el.dataset.stGroup) < 0; });
    form.dataset.film = filmKey;
    $$('[data-st-title-year]').forEach(function (el) { el.textContent = year && year !== 'other' ? year + ' ' : ''; });

    // prices on kit cards (current film) and film cards (difference from the base film, for the current kit)
    Object.keys(cfg.kits).forEach(function (key) {
      var v = variant(key), el = form.querySelector('[data-st-kit-price="' + key + '"]');
      if (el && v) el.textContent = money(v.p);
    });
    var base = variant(k, BASE_FILM);
    form.querySelectorAll('[data-st-film-delta]').forEach(function (el) {
      var v = variant(k, el.dataset.stFilmDelta);
      el.textContent = v && base && v.p > base.p ? '+' + money(v.p - base.p).replace('.00', '') : '';
    });
    form.querySelectorAll('[data-st-shade-label]').forEach(function (el) {
      el.textContent = '· ' + form.elements[el.dataset.stShadeLabel].value.replace(' - ', ' ');
    });
    form.querySelector('[data-st-strip-price]').textContent = '+' + money(strip(k).p);

    // live previews: film colour on the car, shade per covered window
    cars.forEach(function (car) {
      car.dataset.film = filmKey;
      car.querySelectorAll('[data-win]').forEach(function (w) {
        var g = w.dataset.win, on = groups.indexOf(g) >= 0, val = on ? form.elements[g].value : '';
        w.dataset.shade = on ? (val === NANO ? 'nano' : val.split('%')[0]) : '';
        w.classList.toggle('is-covered', on);
      });
    });

    // state tint law: mark shades that are too dark, explain the rules, link to the full law on TintCenter
    var st = state(), warnings = [];
    form.querySelectorAll('.st-shades[data-st-group]').forEach(function (fs) {
      var g = fs.dataset.stGroup;
      fs.querySelectorAll('input[type="radio"]').forEach(function (inp) {
        inp.closest('.st-shade') && inp.closest('.st-shade').classList.toggle('is-too-dark', !!st && GROUPS[k].indexOf(g) >= 0 && tooDark(st, g, inp.value));
      });
    });
    ['front', 'back', 'rear'].forEach(function (g) {
      var el = form.querySelector('[data-st-law-warn="' + g + '"]');
      if (!el) return;
      var bad = !!st && groups.indexOf(g) >= 0 && tooDark(st, g, form.elements[g].value);
      el.hidden = !bad;
      el.textContent = bad ? 'Darker than ' + st.n + ' allows on the street' : '';
      if (bad) warnings.push(GROUP_NAMES[g] + ' at ' + form.elements[g].value.split(' - ')[0]);
    });
    var box = $('[data-st-law-box]');
    if (box && stateSel && stateSel.value === 'XX') {
      box.hidden = false;
      box.innerHTML = '<p>The limits here are for US states. In Canada each province sets its own rules, and other countries differ too: ' + 'check the local rules before choosing dark front shades. Questions? Call <a href="tel:+18773584898">(877) 358-4898</a>.</p>';
    } else if (box) {
      box.hidden = !st;
      if (st) {
        var rows = groups.map(function (g) { return '<li><strong>' + GROUP_NAMES[g] + ':</strong> ' + esc(lawRule(st, g)) + '</li>'; }).join('');
        box.innerHTML = '<p class="st-law__title">' + esc(st.n) + ' tint law' + (mpv ? ' for SUVs, vans and trucks' : '') +
          ' <span class="st-law__by">· source: TintCenter.com</span></p>' +
          '<ul>' + rows + '</ul>' +
          (st.m ? '<p class="st-muted">Measured as: ' + esc(st.m.toLowerCase()) + '. Factory glass is often slightly tinted, so choose a little lighter than the limit.</p>' : '') +
          '<p><a href="' + laws.base + st.h + '" target="_blank" rel="noopener">Full ' + esc(st.n) + ' tint law, exemptions and fines on TintCenter →</a></p>' +
          '<p class="st-muted st-law__note">Limits courtesy of TintCenter.com, checked against the state statute' + (st.v ? ' on ' + esc(st.v) : '') +
          '. A guide, not legal advice.</p>';
      }
    }
    var sum = $('[data-st-law-summary]');
    if (sum) {
      sum.hidden = !warnings.length;
      sum.textContent = warnings.length ? warnings.join(' and ') + ' is darker than ' + st.n + ' allows on the street. You can still order it, for example for a show car, off-road use or with a medical exemption.' : '';
    }

    // summary and total
    var v = variant(k), n = nanoCount(k), total = v ? v.p : 0;
    var html = row(esc(cfg.kits[k].name), v ? money(v.p) : '—');
    html += row('Film', esc(f.replace('HP ', '')));
    groups.forEach(function (g) { html += row(GROUP_NAMES[g], esc(form.elements[g].value.replace(' - ', ' '))); });
    if (n) { html += row('Ultra Nano upgrade' + (n > 1 ? ' × ' + n : ''), money(n * cfg.nano.p)); total += n * cfg.nano.p; }
    if (form.elements.strip.checked) { html += row('Windshield strip', money(strip(k).p)); total += strip(k).p; }
    if (form.elements.tools.checked) { html += row('Tool kit', money(cfg.tools.p)); total += cfg.tools.p; }
    $('[data-st-lines]').innerHTML = html;
    form.querySelectorAll('[data-st-total]').forEach(function (el) { el.textContent = money(total); });
  }

  // analytics: kit_configured once, on the first change after a model year is chosen; kit_add_to_cart on submit
  var track = function (n, d) { if (window.stTrack) window.stTrack(n, d); };
  var kitData = function () {
    var k = kit();
    return { vehicle: location.pathname.split('/').pop(), year: $('#st-year').value, kit: k, film: film(), size: cfg.size,
             rear_type: GROUPS[k].indexOf('rear') >= 0 && form.elements.reartype ? form.elements.reartype.value : '' };
  };
  var configured = false;
  form.addEventListener('change', function () {
    if (configured || !$('#st-year').value) return;
    configured = true; track('kit_configured', kitData());
  });
  form.addEventListener('change', function (e) {
    if (e.target === stateSel) { try { localStorage.setItem('st-state', stateSel.value); } catch (err) { /* private mode */ } }
    update();
  });
  if (lawEl) {
    fetch(lawEl.dataset.src).then(function (r) { return r.json(); }).then(function (d) {
      laws = d;
      d.states.forEach(function (s) {
        var o = document.createElement('option'); o.value = s.c; o.textContent = s.n; stateSel.appendChild(o);
      });
      var other = document.createElement('option'); other.value = 'XX'; other.textContent = 'Outside the US (Canada, other)'; stateSel.appendChild(other);
      var saved = '';
      try { saved = localStorage.getItem('st-state') || ''; } catch (err) { /* private mode */ }
      if (saved && (saved === 'XX' || d.states.some(function (s) { return s.c === saved; }))) stateSel.value = saved;
      update();
    }).catch(function () { lawEl.hidden = true; });
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var err = form.querySelector('[data-st-error]');
    var k = kit(), v = variant(k), year = $('#st-year').value;
    err.hidden = true;
    if (!year) {
      err.textContent = 'Please choose your model year (step 1).'; err.hidden = false;
      $('#st-year').focus(); $('#st-year').scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }
    if (!v) { err.textContent = 'That combination is not available; please contact us.'; err.hidden = false; return; }
    var props = { 'Vehicle': cfg.vehicle, 'Year': year === 'other' ? 'Other (confirm with customer)' : year, 'Body type': BODY_NAMES[cfg.body] || cfg.body };
    GROUPS[k].forEach(function (g) {
      props[{ front: 'Front windows shade', back: 'Back windows shade', rear: 'Rear windshield shade' }[g]] = form.elements[g].value;
    });
    if (GROUPS[k].indexOf('rear') >= 0) props['Rear windshield type'] = form.elements.reartype.value;
    if (form.elements.notes.value.trim()) props['Notes'] = form.elements.notes.value.trim();
    var forLabel = cfg.vehicle + ' ' + (year === 'other' ? '' : year) + ', ' + cfg.kits[k].name;
    var photo = form.elements.photo && form.elements.photo.files[0];
    if (photo && photo.size > 20 * 1024 * 1024) {
      err.textContent = 'That photo is too large. Please choose one under 20 MB.'; err.hidden = false;
      form.elements.photo.focus(); return;
    }
    var items = [{ id: v.id, quantity: 1, properties: props }];
    var n = nanoCount(k);
    if (n) items.push({ id: cfg.nano.id, quantity: n, properties: { 'For': forLabel } });
    if (form.elements.strip.checked) items.push({ id: strip(k).id, quantity: 1, properties: { 'For': forLabel } });
    if (form.elements.tools.checked) items.push({ id: cfg.tools.id, quantity: 1 });
    var btns = form.querySelectorAll('button[type="submit"]');
    btns.forEach(function (b) { b.disabled = true; });
    var kd = kitData(); kd.value = v.p / 100; kd.photo = !!photo; track('kit_add_to_cart', kd);
    var addJson = function (list) {
      if (!list.length) return Promise.resolve();
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: list }) }).then(function (r) { if (!r.ok) throw new Error('cart'); });
    };
    // A photo can't travel in the JSON body: the kit line goes as a form upload (Shopify stores the file and writes its link
    // into the "Vehicle photo" property), then the add-ons as usual. kitAdded stops a retry adding the kit twice.
    var addKit = function () {
      if (!photo) return addJson(items);
      if (kitAdded) return addJson(items.slice(1));
      var fd = new FormData();
      fd.append('id', String(v.id)); fd.append('quantity', '1');
      Object.keys(props).forEach(function (key) { fd.append('properties[' + key + ']', props[key]); });
      fd.append('properties[Vehicle photo]', photo, photo.name);
      return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { if (!r.ok) throw new Error('cart'); kitAdded = true; })
        .then(function () { return addJson(items.slice(1)); });
    };
    addKit()
      .then(function () { location.href = '/cart'; })
      .catch(function () {
        btns.forEach(function (b) { b.disabled = false; });
        err.textContent = 'Could not add to cart. Please try again.'; err.hidden = false;
      });
  });
  var kitAdded = false;
  update();
})();
